import * as React from 'react';
const Check = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-check", ...props },
    React.createElement("polyline", { points: "20 6 9 17 4 12" })));
export default Check;
//# sourceMappingURL=Check.js.map